/**
 * 用户管理
 */

export default [
 /* {
    label: '员工管理',
    icon: 'icon-yonghu',
    permission:'user_manage',
    id:'3',
    children: [*/
      {
        label: '员工管理',
        icon: 'icon-yonghu',
        path: '/emp/manage',
        permission: 'user_manage',
        id:'3-1',
      }
   /* ],
  },*/
];

